import { ElementType, Suspense } from 'react';

// project import
import ContainerSpinner from './ContainerSpinner';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<ContainerSpinner />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
